import EventActionProto from '../event-action-proto';
import TodoListTemplateCollection from "../../gd-model/todo-list/todo-list-template-collection";

class TodoListTemplatesReset extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false);
    }

    process() {
        gd.session._todoListTemplates = new TodoListTemplateCollection(this.data, {parse:true});
    }
}

module.exports = TodoListTemplatesReset;


